import { CategoryPageSection } from '../../types/TemplateConfiguration'
import { AutomatedSections, SectionProductItem } from './types/AutomatedExperience'
import { ProductLaneModel } from './types/ProductLaneModel'
import { ProductTile } from './types/ProductTile'

export function createModelFromAutomatedExperience(
  automatedSections: AutomatedSections,
  sectionNumer: number,
  nextSection?: CategoryPageSection,
): ProductLaneModel {
  const tiles: ProductTile[] = []
  ;(automatedSections.items || []).forEach((item: SectionProductItem) => {
    tiles.push({
      name: item.name,
      description: item.description,
      image: item.image,
      linkUrl: item.linkUrl,
      mpvId: item.mpvId,
      productId: item.productId,
      ...(item.callout && { callout: item.callout }),
      isOutOfStock: item.isOutOfStock,
      ...(item.review && { review: item.review }),
      colorInformation: item.colorInformation?.colorSwatches,
      version: item.version,
      selectedProductVariants: item.selectedProductVariants,
      enableCampaignCallouts: true,
      showPrice: true,
      associatedPageAvailable: true,
      externallyMarketable: true,
    })
  })

  return {
    title: automatedSections.header?.title,
    sectionNumber: sectionNumer,
    type: automatedSections.type,
    sectionId: automatedSections.sectionId,
    ...(nextSection?.nextSectionId && { nextSectionId: nextSection.nextSectionId }),
    ...(nextSection?.nextSectionTitle && { nextSectionTitle: nextSection.nextSectionTitle }),
    subtitle: automatedSections.header?.subtitle,
    hideProductDescription: false,
    enableSeeAllCTA: false,
    tiles: tiles,
    isAutomatedLane: true,
  }
}
